import styled from 'styled-components';

export const Main = styled.main`
  flex-grow: 1; // expand the full height of ID.NEXT

  display: flex;
  flex-direction: column;
`;
